import { metaTagConstants } from "../../../../constants/Web/metaTag.constants";

const initialState = {
    metaListFetching: false,
    metaList: [],
    metaListError: false,

    metaTagListFetching: false,
    metaTagList: [],
    metaTagListError: false,

    metaTagMappingFetching: false,
    metaTagMapping: [],
    metaTagMappingError: false,

    syncFetching: false,
    syncData: null,
    syncError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case metaTagConstants.META_LIST_PENDING:
            return { ...state, metaListFetching: true };
        case metaTagConstants.META_LIST_FULFILLED:
            return { ...state, metaListFetching: false, metaListError: false, metaList: action.payload };
        case metaTagConstants.META_LIST_REJECTED:
            return { ...state, metaListFetching: false, metaListError: action.payload };

        case metaTagConstants.META_TAG_LIST_PENDING:
            return { ...state, metaTagListFetching: true };
        case metaTagConstants.META_TAG_LIST_FULFILLED:
            return { ...state, metaTagListFetching: false, metaTagListError: false, metaTagList: action.payload };
        case metaTagConstants.META_TAG_LIST_REJECTED:
            return { ...state, metaTagListFetching: false, metaTagListError: action.payload };

        case metaTagConstants.META_TAG_MAPPING_PENDING:
            return { ...state, metaTagMappingFetching: true };
        case metaTagConstants.META_TAG_MAPPING_FULFILLED:
            return { ...state, metaTagMappingFetching: false, metaTagMappingError: false, metaTagMapping: action.payload };
        case metaTagConstants.META_TAG_MAPPING_REJECTED:
            return { ...state, metaTagMappingFetching: false, metaTagMappingError: action.payload };

        case metaTagConstants.META_TAG_SYNC_PENDING:
            return { ...state, syncFetching: true };
        case metaTagConstants.META_TAG_SYNC_FULFILLED:
            return { ...state, syncFetching: false, syncError: false, syncData: action.payload };
        case metaTagConstants.META_TAG_SYNC_REJECTED:
            return { ...state, syncFetching: false, syncError: action.payload };
        case metaTagConstants.META_TAG_SYNC_CLEAR:
            return { ...state, syncData: null, syncError: false };

        case "CLEAR_STATE":
            return { ...initialState };
        default:
            return state;
    }
}
